<!-- this desing was done by me before confirmation thats why it is not working  -->
@if(stop()){
<!-- Hidden below 1024px (lg breakpoint) -->
<header class="hidden lg:flex w-full bg-[#e6e6e6] h-10 items-center">
    <div class="container mx-auto px-3 flex justify-between items-center h-full ">

        <!-- LEFT MENU -->
        <!-- <nav class="flex items-center h-full text-[13px] font-semibold text-[#333] space-x-5">
            <span class="cursor-pointer hover:bg-[#2f64a3] hover:text-white">Jobs</span>
            <span class="cursor-pointer">My Bdjobs</span>
            <span class="cursor-pointer">e-Learning</span>
            <span class="cursor-pointer">Tender/EOI</span>

            <span class="cursor-pointer">
                <span class="text-[#B21E7B]">Expert</span> Search
            </span>

            <span class="px-3 py-[2px] bg-[#4c5bd4] text-white rounded cursor-pointer">
                Recruiter
            </span>
            <span class="px-3 py-[2px] bg-[#1aa341] text-white rounded cursor-pointer">
                Post a Job
            </span>
        </nav> -->
        <nav class="flex items-center h-full text-[13px] font-semibold text-[#333]">
            <!-- Jobs (with correct hover style) -->
            <span class="cursor-pointer h-10 flex items-center px-4 transition
           hover:bg-[#2f64a3] hover:text-white">
                Jobs
            </span>

            <span class="cursor-pointer h-10 flex items-center px-4 hover:bg-[#008020] hover:text-white">My
                Bdjobs</span>
            <span
                class="cursor-pointer h-10 flex items-center px-4 hover:bg-[#ac016d] hover:text-white">e-Learning</span>
            <span
                class="cursor-pointer h-10 flex items-center px-4 hover:bg-[#f57f17] hover:text-white">Tender/EOI</span>

            <!-- <span class="cursor-pointer h-10 flex items-center px-4">
                <span class="text-[#B21E7B]">Expert</span>&nbsp;Search
            </span> -->

            <span class="ml-4 px-3 py-[4px] bg-[#4c5bd4] text-white rounded cursor-pointer">
                Recruiter
            </span>
            <span class="px-3 py-[4px] bg-[#008a22] text-white rounded cursor-pointer ml-2 ">
                Post a Job
            </span>
        </nav>


        <!-- RIGHT -->
        <div class="flex items-center text-[#595959] space-x-1">
            <span class="cursor-pointer p-2 icon-youtube py-3 px-3 hover:bg-[#e52d27] hover:text-white"></span>
            <span class="cursor-pointer p-2 icon-facebook py-3 px-3 hover:bg-[#3b5999] hover:text-white"></span>
            <span class="cursor-pointer p-2 icon-google-plus py-3 px-3 hover:bg-[#dc4e41] hover:text-white"></span>
            <span class="cursor-pointer p-2 icon-linkedin py-3 px-3 hover:bg-[#0a66c2] hover:text-white"></span>
            <span class="cursor-pointer p-2 icon-instagram py-3 px-3 hover:bg-[#833ab4] hover:text-white"></span>

            <div class="flex text-[10px] ml-1 border border-gray-300 rounded overflow-hidden">
                <span class="px-2 py-[3px] bg-white cursor-pointer">ENG</span>
                <span class="px-2 py-[3px] bg-[#3a3a3a] text-white cursor-pointer">বাংলা</span>
            </div>
        </div>

    </div>
</header>
}

@else {
<div 
    [class]="!showBanner() && (isProUser() === false) ? ['border-t-2', 'border-[#eb0d74]'] : []"
    class=" w-full bg-[#37474f] lg:bg-[#22426A] relative">
    <div class="flex lg:justify-center mx-4">
        <div class="mx-4 md:mx-auto md:max-w-full lg:max-w-6xl h-[30px] md:h-16 lg:h-[42px] flex-1 hidden lg:flex items-center justify-between text-white"
         [class]="currentUrl() === '/' ? '' : 'max-width-nav'" 
            *transloco="let t; currentLang as currentLang">
            <div class="flex items-center gap-x-4 font-medium text-xs">
                <a href="https://elearning.bdjobs.com/" class="cursor-pointer" target="_blank">{{t('ELearning')}}</a>
                <img [src]="environment.homeImageUrl + 'vertical-bar.svg'" class="w-3 h-3">
        
                <div class="cursor-pointer" (click)="onTenderClick()">{{t('tender')}}</div>
                <img [src]="environment.homeImageUrl + 'vertical-bar.svg'" class="w-3 h-3">

                <!-- <a (click)="expertSearchRedirect()" class="cursor-pointer" target="_blank">{{t('expert')}}</a>
                <img src="images/vertical-bar.svg" class="w-3 h-3"> -->

                <a href="https://recruiter.bdjobs.com/" class="cursor-pointer" target="_blank">
                    {{t('recruiter')}}
                </a>
                <img [src]="environment.homeImageUrl + 'vertical-bar.svg'" class="w-3 h-3">
        
                <!-- 🔑 Post a Job Wrapper -->
                 @if(isEligibleForPersonalHiring()){
                    <div class="relative flex items-center cursor-pointer" #postJobTrigger (click)="onClickPostJob($event)">
                    
                        <p>{{t('post_a_job')}}</p>
                        <img [src]="environment.homeImageUrl + 'chevron-down.svg'" class="ml-1">
                    
                        @if (isShowPostJobTooltip()) {
                        <div #postJobTooltip (click)="$event.stopPropagation()" class="absolute left-1/2 top-8 z-50 mt-3 min-w-72 -translate-x-1/2
                                                           rounded-xl border border-gray-200 bg-white shadow-lg p-2
                                                           text-sm text-gray-900">
                    
                            <!-- Arrow -->
                            <div class="absolute -top-2 left-1/2 h-4 w-4 -translate-x-1/2
                                                             rotate-45 bg-white border-l border-t border-gray-200">
                            </div>
                    
                            <!-- Item 1 -->
                            <a href="https://recruiter.bdjobs.com/jobposting/" target="_blank"
                                class="px-2 py-2.5 rounded-md hover:bg-gray-50 text-sm block">
                                {{t('post_job_for_your_company')}}
                            </a>
                    
                            <!-- Item 2 -->
                            <!-- <a class="flex items-center gap-2 px-2 py-2 rounded-md hover:bg-gray-50 text-sm"
                                href="https://mybdjobs.bdjobs.com/personalizedjobpost/bn/job-post/info" target="_blank">
                                <span class="whitespace-nowrap">{{t('post_Job_for_personal_hiring')}}</span>
                                <span class="rounded-full bg-[#EEF4FF] px-2 py-0.5 text-xs font-medium
                                                               text-[#3538CD] border border-[#C7D7FE]">
                                    {{t('new')}}
                                </span>
                            </a> -->
                    
                        </div>
                        }
                    </div>
                 }
                 @else {
                    <a href="https://recruiter.bdjobs.com/jobposting/" target="_blank">
                        <p>{{t('post_a_job')}}</p>
                    </a>
                 }
                
            </div>
            <div class="flex gap-x-4">
                <div class="max-h-[30px]">
                    @if(currentUrl()=== '/'){
                    <!-- <div
                            class="relative hidden md:inline-block w-[98px] shadow-sm rounded-full  px-0.5 py-0.5">
                            <input type="checkbox" id="changeLanguage" [checked]="activeLang() === 'bn'"
                                (change)="toggleLang($event)" class="sr-only peer" />
                            <label for="changeLanguage"
                                class="toggle-label block h-[30px] cursor-pointer overflow-hidden rounded-full bg-white"></label>
        
                            <div [class.left-0.5]="activeLang()==='en'" [class.left-0]="activeLang()==='bn'"
                                class="toggle-button absolute top-[3px]  h-[27px] w-[46px] rounded-full  bg-[#c13e8a] transform transition-transform peer-checked:translate-x-full peer-checked:border-white ">
                            </div>
        
                            <span
                                class="pointer-events-none absolute left-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-white peer-checked:text-[#757575]">
                                ENG
                            </span>
                            <span
                                class="pointer-events-none absolute right-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-[#757575] peer-checked:text-white">
                                বাংলা
                            </span>
                        </div> -->
        
                    <div
                        class="relative hidden bg-white md:inline-block w-[96px] max-h-fit shadow-sm rounded-full border border-gray-100 px-0.5 py-0.5">
                        <input type="checkbox" id="changeLanguage" [checked]="activeLang() === 'bn'"
                            (change)="toggleLang($event)" class="sr-only peer" />
                        <label for="changeLanguage"
                            class="toggle-label block h-6 cursor-pointer overflow-hidden rounded-full bg-white"></label>
                        <div [class.left-0.5]="activeLang()==='en'" [class.left-0]="activeLang()==='bn'"
                            class="toggle-button absolute top-[2px]  h-[24px] w-[46px] rounded-full  bg-[#c13e8a] transform transition-transform peer-checked:translate-x-full peer-checked:border-white">
                        </div>
                        <span
                            class="pointer-events-none absolute left-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-white peer-checked:text-[#757575]">
                            ENG
                        </span>
                        <span
                            class="pointer-events-none absolute right-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-[#757575] peer-checked:text-white">
                            বাংলা
                        </span>
                    </div>
                    }
                </div>
                <div class="flex items-center gap-x-1 font-medium text-xs cursor-pointer" (click)="onClickContactUs()">
                    <img [src]="environment.homeImageUrl + 'phone-nav.svg'" alt="">
                    <p>{{t('contact_us')}}</p>
                </div>
        
            </div>
        
        </div>
        <a 
            href="https://play.google.com/store/apps/details?id=com.bdjobs.app"
            class="block md:hidden w-full text-white py-2.5 flex items-center gap-1.5 text-xs justify-center text-center">
            <span class="icon-google-play"></span>
            Download Bdjobs App
        </a>
        @if(!showBanner() && isProUser() === false){
            <div>
                <span (click)="showBanner.set(true)"
                    class="block text-end icon-angle-down text-black p-0.5 rounded-b-sm bg-[#eb0d74] text-xl cursor-pointer ">
                </span>
            </div>
            
        }
        <!-- <div [class.hidden]="showBanner() || isProUser()">
            <span (click)="showBanner.set(true)" class="block text-end icon-angle-down text-black p-0.5 rounded-b-sm bg-[#eb0d74] text-xl cursor-pointer "></span>
        </div> -->
    </div>
    
</div>



}